import { OP } from "../../constant";

// ------------- > TARRIF ACTIONS < ----------- //
// list tarrifs
export function listTarrifRequest(token, data) {
  return {
    type: OP.LIST_TARRIF_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function listTarrifReset() {
  return {
    type: OP.LIST_TARRIF_RESET,
  };
}

// create tarrif
export function createTarrifRequest(token, data) {
  return {
    type: OP.CREATE_TARRIF_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function createTarrifReset() {
  return {
    type: OP.CREATE_TARRIF_RESET,
  };
}

// update tarrif
export function updateTarrifRequest(token, data) {
  return {
    type: OP.UPDATE_TARRIF_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function updateTarrifReset() {
  return {
    type: OP.UPDATE_TARRIF_RESET,
  };
}

// delete tarrif
export function deleteTarrifRequest(token, data) {
  return {
    type: OP.DELETE_TARRIF_REQUEST,
    payload: {
      token,
      data,
    },
  };
}

export function deleteTarrifReset() {
  return {
    type: OP.DELETE_TARRIF_RESET,
  };
}
